'use client';

import Image from 'next/image';
import styles from './asthmaCanadaLogo.module.scss';
import useScreenStore from '@/stores/screen';

export default function AsthmaCanadaLogo() {
  const { isExpanded } = useScreenStore();
  return (
    <div className={styles.logo} style={isExpanded ? { display: 'none' } : {}}>
      <Image
        className={styles.image}
        src="https://asthma-staging-public-storage.s3.ca-central-1.amazonaws.com/asthma-canada-main-logo.png"
        alt="Asthma Canada Logo"
        width={50}
        height={50}
      />
    </div>
  );
}
